/**
 * Helper для форматирования `RunRecord.errorMessage` в человекочитаемую строку
 * (фича 023, FR-020).
 *
 * Контракт `RunErrorMessageSchema` (`@efes/shared/contracts/reconciliation`):
 *   { phase, ruleId, message, stack? }
 * Stack-trace НЕ показывается (FR-020). Формат вывода:
 *   "phase: message" — типичный случай;
 *   "phase [ruleId]: message" — если правило идентифицировано.
 *
 * Вынесен в отдельный модуль (без зависимостей на `@/`-alias) для unit-тестирования.
 */
export function errorMessageFromRun(errorMessage: unknown): string | null {
	if (!errorMessage) return null;
	if (typeof errorMessage === "string") return errorMessage;
	if (typeof errorMessage === "object" && errorMessage !== null) {
		const obj = errorMessage as {
			phase?: string;
			ruleId?: string | null;
			message?: string;
		};
		const phaseLabel = obj.phase && obj.ruleId ? `${obj.phase} [${obj.ruleId}]` : (obj.phase ?? "");
		const parts: string[] = [];
		if (phaseLabel) parts.push(phaseLabel);
		if (obj.message) parts.push(obj.message);
		const formatted = parts.join(": ");
		if (formatted) return formatted;
		// Sprint 6 / C5.3: final fallback — сериализуем объект целиком (truncated),
		// чтобы пользователь увидел raw error-payload вместо пустой строки.
		// Пустой `{}` всё ещё → null (полное отсутствие данных = нет смысла
		// показывать «{}» в toast'е).
		const keys = Object.keys(errorMessage as Record<string, unknown>);
		if (keys.length === 0) return null;
		try {
			return JSON.stringify(errorMessage).slice(0, 200);
		} catch {
			return null;
		}
	}
	return null;
}
